import { render, staticRenderFns } from "./BusinessDetails.vue?vue&type=template&id=103e6e1b"
import script from "./BusinessDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessDetails.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports